import { FIELD_VALUE_FORMAT } from '@constants'
import { GETStoredValueType } from '@types'

export const formatStoredValue = (value: GETStoredValueType) => {
  const parsedValue = value.value.length ? JSON.parse(value.value) : value.value

  if (value.valueObject.valueFormat === FIELD_VALUE_FORMAT.BOOLEAN) {
    if (parsedValue === 'false') {
      return false
    }
    if (parsedValue === 'true') {
      return true
    }
  }

  if (value.valueObject.valueFormat === FIELD_VALUE_FORMAT.NUMBER) {
    if (parsedValue === '1') {
      return 1
    }
    if (parsedValue === '0') {
      return 0
    }
  }

  return parsedValue
}
